var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('compendium-browser',{attrs:{"headers":_vm.headers,"items":_vm.frames}},[_vm._v("Frames")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }